module.exports = __webpack_public_path__ + "static/favicon-916b59b5235ad355f7be814845b22860.ico";